import * as React from 'react';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import {
  FilKompletteringDocumentListItem,
  PostFilesServerResponseObject,
  INTYG_FILE_MIMETYPES,
  BASE_URL,
} from './IntygKomplettering.types';
import { Expander } from 'sos-common/js/components/Expander/Expander';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { stringWithLineBreak, setInnerHtml } from 'sos-common/js/utils/helpers';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { postFile, deleteFile } from 'sos-eservice-common/js/services/files.service';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';
import { sendCompletion } from 'sos-eservice-common/js/services/completion.service';
import { DialogueError } from 'sos-common/js/components/DialogueError/DialogueError';
import { dialogueErrorBody } from 'sos-eservice-common/js/config/dialogueErrorBodies';
import { getDialogueByResponse } from '../../helpers/dialogue.helper';

export interface IIntygKompletteringProps {
  expandHeading: string;
  expandIcon?: string;
  expandCssClass?: string;
  fileHeading: string;
  innerHeading?: string;
  innerParagraph?: string;
  ansokanId: string;
  documentList?: FilKompletteringDocumentListItem[];
  kompletteringId?: string;
  Files: FileExtendedDetails[];
  dhsId?: string;
}

export interface IIntygKompletteringState {
  kompletteringId: string;
  unlockSendButton: boolean;
  fileUploadState: FileExtendedDetails[];
  serverResponseObject: PostFilesServerResponseObject;
  IsInskickad: boolean;
  clientError: clientError;
  showDialog: boolean;
  sendSuccess: boolean;
  sendCompletionErrorMessage: string;
  isErrorModalOpen: boolean;
}

export class IntygKomplettering extends React.Component<IIntygKompletteringProps, IIntygKompletteringState> {
  private _latestResponseError: ResponseError;

  constructor(props: IIntygKompletteringProps) {
    super(props);

    this.state = {
      kompletteringId: props.kompletteringId,
      unlockSendButton: props.Files.length > 0,
      fileUploadState: props.Files,
      serverResponseObject: null,
      IsInskickad: false,
      clientError: null,
      showDialog: false,
      sendSuccess: null,
      sendCompletionErrorMessage: '',
      isErrorModalOpen: false,
    };
  }

  setClientError = (errorMessage: string) => {
    this.setState({
      clientError: {
        error: null,
        errorMessage: errorMessage || 'Ett ohanterat fel inträffade.',
      },
    });
  };

  onAddFile = (field: FormFieldFile) => {
    const { ansokanId } = this.props;
    const { kompletteringId } = this.state;

    this.setState({
      fileUploadState: field.value,
      unlockSendButton: false,
    });

    const apiEndpoint = `${BASE_URL}/ansokan/${ansokanId}/komplettering/${kompletteringId}`;
    postFile<PostFilesServerResponseObject>(field, apiEndpoint, new FormData()).then((response) => {
      if (response instanceof ResponseError) {
        this._latestResponseError = response;
        if (!response.body.detailCode) {
          this.setClientError(response.body.errorMessage);
        } else {
          this.setState({ isErrorModalOpen: true });
        }
        const files = field.value.filter((file) => !!file.FileId);
        this.setState({ fileUploadState: files });
      } else {
        this.setState({
          kompletteringId: response.serverResponse.kompletteringId,
          unlockSendButton: response.fileUploadValue.length > 0,
          fileUploadState: response.fileUploadValue,
          serverResponseObject: response.serverResponse,
          clientError: null,
        });
      }
    });
  };

  onDeleteFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    const { ansokanId } = this.props;
    const { kompletteringId } = this.state;

    const apiEndpoint = `${BASE_URL}/ansokan/${ansokanId}/komplettering/${kompletteringId}/fil/${file.FileId}`;

    deleteFile(apiEndpoint, new FormData()).then((response) => {
      if (response instanceof ResponseError) {
        this._latestResponseError = response;
        if (!response.body.detailCode) {
          this.setClientError(response.body.errorMessage);
        } else {
          this.setState({ isErrorModalOpen: true });
        }
      } else {
        const fileId = (response as any).FileId;
        let newFileUploadState = this.state.fileUploadState.slice();
        let index = newFileUploadState.findIndex((val) => {
          return val.FileId === fileId;
        });
        newFileUploadState.splice(index, 1);

        this.setState({
          fileUploadState: newFileUploadState,
          clientError: null,
          unlockSendButton: newFileUploadState.length > 0,
        });
      }
    });
  };

  onSendClick = () => {
    const { ansokanId } = this.props;
    const { kompletteringId } = this.state;

    const apiEndpoint = `${BASE_URL}/ansokan/${ansokanId}/komplettering/${kompletteringId}/submit`;
    const formData = new FormData();

    sendCompletion(apiEndpoint, formData).then((response) => {
      if (response instanceof ResponseError) {
        this._latestResponseError = response;
        this.setState({
          showDialog: true,
          sendSuccess: null,
          isErrorModalOpen: true,
          sendCompletionErrorMessage: response.body.errorMessage || 'Ett ohanterat fel inträffade.',
        });
      } else {
        this.setState({
          showDialog: true,
          sendSuccess: true,
          isErrorModalOpen: false,
        });
      }
    });
  };

  renderFileItem = (item: FilKompletteringDocumentListItem) => {
    return (
      <div key={item.fileName} className="filelist-item filelist-item--nodate">
        <div className="filelist-item__name">
          <a className={`file-extension-icon ${item.fileExtension}`} href={item.url}>
            {item.fileName}
          </a>
        </div>
      </div>
    );
  };

  closeConfirm = () => {
    window.location.reload();
  };

  renderSuccessDialog = () => {
    return (
      <Dialog isOpen={this.state.showDialog} onRequestClose={this.closeConfirm}>
        <button onClick={this.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>
        <div className="header">
          <h2>{'Uppladdningen lyckades'}</h2>
        </div>
        <p>{'Din komplettering är nu skickad.'}</p>
        <div className="footer">
          <input type="submit" className="button" onClick={this.closeConfirm} value={'Stäng'} />
        </div>
      </Dialog>
    );
  };

  failDialogueBody = (): dialogueErrorBody => {
    const { sendCompletionErrorMessage } = this.state;
    return {
      body: (
        <React.Fragment>
          <div className="header">
            <h2>Ett oväntat fel har inträffat</h2>
          </div>
          <p>Du kan avbryta och försöka spara och stänga igen om en stund.</p>
          {sendCompletionErrorMessage && (
            <React.Fragment>
              <p>Om felet kvarstår kan du kontakta Socialstyrelsen och ange följande felkod:</p>
              <div className="error-code">{sendCompletionErrorMessage}</div>
            </React.Fragment>
          )}
        </React.Fragment>
      ),

      buttons: [
        {
          text: 'Stäng',
          cssClassNames: 'button',
          redirectUrl: null,
        },
      ],
    };
  };

  renderFailDialog = () => {
    return (
      <Dialog isOpen={this.state.showDialog} onRequestClose={this.closeConfirm}>
        <button onClick={this.closeConfirm} className="close">
          <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
        </button>
        <div className="header">
          <h2>Ett oväntat fel har inträffat</h2>
        </div>
        <p>Försök skicka in kompletteringen igen om en stund.</p>
        <div className="error-code">{this.state.sendCompletionErrorMessage}</div>
      </Dialog>
    );
  };

  onModalClose = () => {
    this.setState({
      isErrorModalOpen: false,
    });
  };

  public render() {
    const { expandIcon, expandCssClass, fileHeading, innerHeading, innerParagraph, documentList, dhsId } = this.props;
    const { unlockSendButton, clientError, fileUploadState, sendSuccess, isErrorModalOpen } = this.state;

    let expandHeading = this.props.expandHeading;
    if (dhsId) expandHeading += ` - ${dhsId}`;

    return (
      <>
        {isErrorModalOpen && (
          <DialogueError
            dialogueErrorBody={getDialogueByResponse(this._latestResponseError, '#', this.failDialogueBody())}
            isModalOpen={isErrorModalOpen}
            onModalClose={this.onModalClose}
            enableCloseIcon={false}
            shouldCloseOnOverlayClick={false}
          />
        )}

        <Expander isExpanded={false} heading={expandHeading} icon={expandIcon} cssClass={expandCssClass}>
          {innerHeading && <h3>{innerHeading}</h3>}
          <p dangerouslySetInnerHTML={setInnerHtml(stringWithLineBreak(innerParagraph))}></p>

          {documentList && documentList.map(this.renderFileItem)}

          <Fileupload
            id={dhsId}
            disabled={false}
            max={10}
            heading={fileHeading}
            upload="Ladda upp fil"
            value={fileUploadState}
            nofilesText="Du har inte laddat upp någon fil ännu"
            mimetype={INTYG_FILE_MIMETYPES}
            onAdd={this.onAddFile}
            onRemove={this.onDeleteFile}
            maxFileSize={10485760} //10 mb
            clientError={clientError}
          />
          <hr className="expand-block__hr" />
          <div className="centered-button">
            <button disabled={!unlockSendButton} onClick={this.onSendClick} className="button">
              Skicka komplettering
            </button>
          </div>
        </Expander>

        {sendSuccess && this.renderSuccessDialog()}
      </>
    );
  }
}
